export const containerClassName =
   'pr-[12px] py-[8px] rounded-[10px] transition-colors duration-200 mb-[4px]'

export const contentContainerClassName = 'flex items-center relative'

export const iconContainerClassName = 'mr-12px'

export const nameClassName = 'text-sm-medium truncate flex-1'
